// @ts-nocheck
import { PreferencesEstimatesBoot } from './PreferencesEstimatesFormBoot';
import { PreferencesEstimatesFormPage } from './PreferencesEstimatesFormPage';

/**
 * Estimates preferences.
 */
export function PreferencesEstimates() {
  return (
    <PreferencesEstimatesBoot>
      <PreferencesEstimatesFormPage />
    </PreferencesEstimatesBoot>
  );
}
